import React from "react";
import T from "prop-types";
import styled from "styled-components/macro";
import Typography from "commons/components/Typography";
import { useTranslation } from "react-i18next";
import LiveCounters from "./LiveCounters";
import RequestAccessForm from "./RequestAccessForm";
import { BREAKPOINTS } from "commons/util/breakpoints";
import Flexbox from "commons/components/Flexbox";

const Box = styled(Flexbox)`
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 32px;
  color: var(--brown-100);
  font-size: 14px;
  line-height: 20px;
  border-top: 1px solid var(--neutral-180);
  background-color: var(--neutral-200);
  border-radius: 0;
  margin-top: auto;
  position: sticky;
  bottom: 0;

  @media (max-width: ${BREAKPOINTS.medium}) {
    position: static;
    padding-top: 48px;
    padding-bottom: 48px;
  }
`;

const RequestAccessFormStyled = styled(RequestAccessForm)`
  margin-left: -4px;
`;

function CTASection() {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography marginBottom={16} variant="label">
        Coming early 2027. <br />
        Sign up to get early access.
      </Typography>

      <LiveCounters />

      <RequestAccessFormStyled />
    </Box>
  );
}

CTASection.propTypes = {
  className: T.string,
  icon: T.string,
  title: T.string,
  description: T.string,
  isActive: T.bool,
  onClick: T.func,
};

export default CTASection;
